var workspace = ''

$('#btn-alerts').on('click', function () {
    if ($('#user-id').val() !== undefined) {
        email.list.areas()
        $('#email-modal').modal('show')
        //$('#select-email-categories').select2()
    } else {
        localStorage.alertsModalFlag = true
        location.href = `${workspace}/login`
    }
})

$('.photo-upload-menu').on('click', function () {
    if ($('#user-id').val() !== undefined) {
        if (location.href.includes('webgis')) {
            email.list.areas()
            $('#upload-modal').modal('show');
        } else {
            localStorage.photoUploadModalFlag = true
            location.href = `${workspace}/webgis`
        }
    } else {
        location.href = `${workspace}/login`
        localStorage.photoUploadModalFlag = true
    }
})
/*
$('#select-email-biomes').on('change', function () {
    email.refresh.categories()
    //Sort
})
*/
$('#select-email-categories').on('change', function () {
    email.refresh.areas()
})

$('.email-close-button').on('click', function () {
    $('#email-modal').modal('hide')
})

$('#email-save-button').on('click', function () {
    email.save.areas()
})


$('.email-area-move').on('click', function () {
    if ($(this).attr('id') == 'email-add-button') {
        $("#select-email-areas option:selected").each(function (index) {
            $("#select-email-selected-areas").append($("<option></option>").attr("value", $(this).val()).text($(this).text()))
            $(this).remove();
        })
    }
    else if ($(this).attr('id') == 'email-add-all-button') {
        $("#select-email-areas option").each(function (index) {
            $("#select-email-selected-areas").append($("<option></option>").attr("value", $(this).val()).text($(this).text()))
            $(this).remove();
        })
    }
    if ($(this).attr('id') == 'email-remove-button') {
        $("#select-email-selected-areas option:selected").each(function (index) {
            $("#select-email-areas").append($("<option></option>").attr("value", $(this).val()).text($(this).text()))
            $(this).remove();
        })
    }
    else if ($(this).attr('id') == 'email-remove-all-button') {
        $("#select-email-selected-areas option").each(function (index) {
            $("#select-email-areas").append($("<option></option>").attr("value", $(this).val()).text($(this).text()))
            $(this).remove();
        })
    }

    email.sort.select()
})


const email = {
    workspace: '/platform',
    list: {
        areas: () => {
            if ($('#user-id').val() !== undefined) {
                $.ajax({ url: `${email.workspace}/submission/list/${$('#user-id').val()}` }).done(function (areas) {
                    var $el = $("#select-email-selected-areas")
                    $el.empty()
                    $.each(areas, function (key, area) {
                        $el.append($("<option></option>").attr("value", area.id).text(area.name))
                        $(`#select-email-areas option[value='${area.id}']`).remove();
                    })
                })
                email.sort.select()
            }
        }
    },
    refresh: {
        areas: () => {
            $.ajax({ url: `${email.workspace}/categories/${$('#select-email-categories').val()}/areas` }).done(function (areas) {
                var $el = $("#select-email-areas")
                $el.empty()
                $.each(areas, function (key, area) {
                    if ($(`#select-email-selected-areas option[value=${area.id}]`).length < 1) {
                        $el.append($("<option></option>").attr("value", area.id).text(area.name))
                    }
                })
            })
        },
        categories: () => {
            $.ajax({ url: `${email.workspace}/category/${$('#select-email-biomes').val()}` }).done(function (categories) {
                var $el = $("#select-email-categories")
                $el.empty()
                $.each(categories, function (key, category) {
                    $el.append($("<option></option>").attr("value", category.id).text(category.name))
                })
                email.refresh.areas()
            })
        },
        biomes: () => {
            $.ajax({ url: `${email.workspace}/biome` }).done(function (biomes) {
                var $el = $("#select-email-biomes")
                $.each(biomes, function (key, biome) {
                    $el.append($("<option></option>").attr("value", biome.id).text(biome.name))
                })

                email.refresh.categories()
            })
        }
    },
    save: {
        areas: () => {
            areasIds = []

            $("#select-email-selected-areas option").each(function () {
                areasIds.push($(this).val())
            })

            $.ajax({ url: `${email.workspace}/submission/insert/${$('#user-id').val()}/${areasIds.join()}` }).done(function () {
                $.notify(`As configurações de envio foram salvas.\nSending settings have been saved.`, { className: "success", position: "right bottom" });
            }).fail(function (jqXHR, textStatus) {
                $.notify("Erro ao salvar configurações.<br />Error saving sending settings.", "error");
            });

            $('.email-close-button').click()
        }
    },
    sort: {
        select: () => {
            ids = ['select-email-areas', 'select-email-selected-areas']
            for (index in ids) {
                options = $(`#${ids[index]} option`);

                options.sort(function (a, b) {
                    if (a.text > b.text) return 1;
                    else if (a.text < b.text) return -1;
                    else return 0;
                });

                $(`#${ids[index]}`).empty().append(options);
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    email.list.areas()
    email.refresh.areas()

    if (localStorage.alertsModalFlag === "true" && location.href.includes('webgis')) {
        localStorage.alertsModalFlag = false
        email.list.areas()
        $('#email-modal').modal('show')
    }
})